export default "__VITE_ASSET__Ak56paG$__"